// NOTE: NSAI-6755 — how long the SSO warning toast stays up after a sign-in the
// temporary SAML legacy-domain compatibility mode let through. Longer than a
// regular toast on purpose: it asks the user to pass an action on to their
// organization owner, and the page navigates to the chat right after it opens.
export const SSO_WARNING_TOAST_DURATION_MS = 15_000 as const;

// NOTE: NSAI-6755 — the toaster clamps every title to three lines, which cut
// this warning off right before its instruction (who verifies the domain, and
// where). Lifted for this one toast rather than for the whole toaster.
export const SSO_WARNING_TOAST_TITLE_CLASS_NAME = "!line-clamp-none" as const;
